module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"back":"戻る","post":"投稿する","input_caption":"キャプションを入力してください。"}}')
  delete Component.options._Ctor
}
